import type { Item } from "~/types/api";
import { TaskExplorerMinimizedWindow } from "./task-explorer-min-window";
import { useTabWindowsContext } from "../../tab-windows/hooks/use-tab-windows-context";

export const MinimizedWindowTray = () => {
  const { minimizedWindows, maximizeWindow, closeWindow, togglePin } = useTabWindowsContext<Item>();

  if (minimizedWindows.length === 0) return null;

  return (
    <div className="fixed right-4 bottom-0 z-50 flex max-w-sm flex-col">
      {minimizedWindows.map((state) => (
        <TaskExplorerMinimizedWindow
          key={`${state.title}-${state.id}`}
          id={state.id}
          title={state.title}
          isPinned={state.isPinned}
          onPin={togglePin}
          onMaximize={maximizeWindow}
          onClose={closeWindow}
        />
      ))}
    </div>
  );
};
